import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import { UserRoleLegacy } from '@getaccept/lib-shared/src/users/types/user-role-legacy';
import type { MergeValues, Node } from '../../types';
import { Context } from '../../types';
import { gaTopbarHeight, documentViewFloatingTopbarHeight } from '../../constants/ga-topbar-height';

export const getTopBarHeight = (context: Context): number => {
  const floatingTopbarHeight =
    context === Context.DocumentView ? documentViewFloatingTopbarHeight : 0;

  return gaTopbarHeight + floatingTopbarHeight;
};

export const getIsAdmin = (userRole: UserRoleLegacy): boolean => userRole === UserRoleLegacy.Admin;

export const getRoles = (mergeValues: MergeValues): Recipient[] =>
  mergeValues?.recipients?.filter(
    (recipient: Recipient) => !!recipient.roleName && !recipient.email && !recipient.mobile
  ) || [];

export const getRecipients = (mergeValues: MergeValues): Recipient[] =>
  mergeValues?.recipients?.filter(
    (recipient: Recipient) => !!recipient.email || !!recipient.mobile
  ) || [];

export const getIsLocked = (node: Node): boolean => !!node?.locked;
